// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.profile-view-container {
  padding: 1rem 2rem;
  width: 100%;
  margin: 0 auto;
  animation: fadeIn 0.3s ease-in;
}
@media (max-width: 768px) {
  .profile-view-container {
    padding: 1rem;
  }
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
.profile-view-header {
  margin-bottom: 1rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;
}
.profile-view-header .back-to-reports-btn {
  text-decoration: none;
  color: #667eea;
  font-size: 0.95rem;
  font-weight: 500;
  padding: 0;
  transition: all 0.2s ease;
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  align-self: flex-start;
}
.profile-view-header .back-to-reports-btn:hover {
  color: #5568d3;
  text-decoration: none;
  transform: translateX(-5px);
}
.profile-view-header .back-to-reports-btn i {
  font-size: 1rem;
}
.profile-view-header .profile-view-title {
  font-size: 2rem;
  font-weight: 700;
  color: #2c3e50;
  margin: 0;
  display: flex;
  align-items: center;
}
@media (max-width: 768px) {
  .profile-view-header .profile-view-title {
    font-size: 1.5rem;
  }
}
.profile-view-header .profile-view-title i {
  color: #667eea;
}

.profile-card {
  border: none;
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  overflow: hidden;
  transition: all 0.3s ease;
  max-height: calc(100vh - 200px);
  display: flex;
  flex-direction: column;
}
.profile-card:hover {
  box-shadow: 0 6px 25px rgba(0, 0, 0, 0.12);
}
.profile-card .card-body {
  padding: 2.5rem;
  overflow-y: auto;
  overflow-x: hidden;
}
@media (max-width: 768px) {
  .profile-card .card-body {
    padding: 1.5rem;
  }
}
.profile-card .card-body::-webkit-scrollbar {
  width: 8px;
}
.profile-card .card-body::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 10px;
}
.profile-card .card-body::-webkit-scrollbar-thumb {
  background: #667eea;
  border-radius: 10px;
}
.profile-card .card-body::-webkit-scrollbar-thumb:hover {
  background: #5568d3;
}

.profile-section:not(:first-child) {
  margin-top: 2.5rem;
}
.profile-section .profile-section-title {
  font-size: 1.1rem;
  font-weight: 700;
  color: #667eea;
  margin-bottom: 1.5rem;
  padding-bottom: 0.75rem;
  border-bottom: 2px solid #e8ecff;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}
.profile-section .profile-section-title::before {
  content: "";
  width: 4px;
  height: 20px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-radius: 2px;
}

.profile-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 1rem 4rem;
}
@media (max-width: 768px) {
  .profile-grid {
    grid-template-columns: 1fr;
    gap: 0.75rem;
  }
}

.profile-field {
  display: grid;
  grid-template-columns: 150px 1fr;
  gap: 1rem;
  align-items: baseline;
  padding: 0.5rem 0;
}
@media (max-width: 768px) {
  .profile-field {
    grid-template-columns: 120px 1fr;
    gap: 0.75rem;
  }
}
.profile-field.profile-field-full {
  grid-column: 1/-1;
}
.profile-field dt {
  font-weight: 600;
  color: #666;
  font-size: 0.875rem;
  margin: 0;
}
@media (max-width: 768px) {
  .profile-field dt {
    font-size: 0.85rem;
  }
}
.profile-field dd {
  margin: 0;
  color: #000;
  font-size: 0.95rem;
  font-weight: 400;
  word-break: break-word;
}
@media (max-width: 768px) {
  .profile-field dd {
    font-size: 0.9rem;
  }
}
.profile-field dd i.fa-check-circle {
  font-size: 1.1rem;
}
.profile-field dd i.fa-times-circle {
  font-size: 1.1rem;
}

@media (max-width: 768px) {
  .profile-view-container .profile-section {
    margin-top: 1.5rem !important;
  }
  .profile-view-container .profile-section:first-child {
    margin-top: 0 !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/containers/power-bi-portal/components/ProfileView.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,WAAA;EAEA,cAAA;EACA,8BAAA;AAAF;AAEE;EAPF;IAQI,aAAA;EACF;AACF;;AAEA;EACE;IACE,UAAA;IACA,2BAAA;EACF;EACA;IACE,UAAA;IACA,wBAAA;EACF;AACF;AAEA;EACE,mBAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;AAAF;AAEE;EACE,qBAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,UAAA;EACA,yBAAA;EACA,oBAAA;EACA,mBAAA;EACA,WAAA;EACA,sBAAA;AAAJ;AAEI;EACE,cAAA;EACA,qBAAA;EACA,2BAAA;AAAN;AAGI;EACE,eAAA;AADN;AAKE;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,SAAA;EACA,aAAA;EACA,mBAAA;AAHJ;AAKI;EARF;IASI,iBAAA;EAFJ;AACF;AAII;EACE,cAAA;AAFN;;AAOA;EACE,YAAA;EACA,mBAAA;EACA,0CAAA;EACA,gBAAA;EACA,yBAAA;EACA,+BAAA;EACA,aAAA;EACA,sBAAA;AAJF;AAME;EACE,0CAAA;AAJJ;AAOE;EACE,eAAA;EACA,gBAAA;EACA,kBAAA;AALJ;AAOI;EALF;IAMI,eAAA;EAJJ;AACF;AAOI;EACE,UAAA;AALN;AAQI;EACE,mBAAA;EACA,mBAAA;AANN;AASI;EACE,mBAAA;EACA,mBAAA;AAPN;AASM;EACE,mBAAA;AAPR;;AAcE;EACE,kBAAA;AAXJ;AAcE;EACE,iBAAA;EACA,gBAAA;EACA,cAAA;EACA,qBAAA;EACA,uBAAA;EACA,gCAAA;EACA,aAAA;EACA,mBAAA;EACA,WAAA;AAZJ;AAcI;EACE,WAAA;EACA,UAAA;EACA,YAAA;EACA,6DAAA;EACA,kBAAA;AAZN;;AAkBA;EACE,aAAA;EACA,qCAAA;EACA,cAAA;AAfF;AAiBE;EALF;IAMI,0BAAA;IACA,YAAA;EAdF;AACF;;AAkBA;EACE,aAAA;EACA,gCAAA;EACA,SAAA;EACA,qBAAA;EACA,iBAAA;AAfF;AAiBE;EAPF;IAQI,gCAAA;IACA,YAAA;EAdF;AACF;AAiBE;EACE,iBAAA;AAfJ;AAkBE;EACE,gBAAA;EACA,WAAA;EACA,mBAAA;EACA,SAAA;AAhBJ;AAkBI;EANF;IAOI,kBAAA;EAfJ;AACF;AAkBE;EACE,SAAA;EACA,WAAA;EACA,kBAAA;EACA,gBAAA;EACA,sBAAA;AAhBJ;AAkBI;EAPF;IAQI,iBAAA;EAfJ;AACF;AAiBI;EACE,iBAAA;AAfN;AAkBI;EACE,iBAAA;AAhBN;;AAsBA;EAEI;IACE,6BAAA;EApBJ;EAsBI;IACE,wBAAA;EApBN;AACF","sourcesContent":[".profile-view-container {\r\n  padding: 1rem 2rem;\r\n  width: 100%;\r\n  //max-width: 1400px;\r\n  margin: 0 auto;\r\n  animation: fadeIn 0.3s ease-in;\r\n\r\n  @media (max-width: 768px) {\r\n    padding: 1rem;\r\n  }\r\n}\r\n\r\n@keyframes fadeIn {\r\n  from {\r\n    opacity: 0;\r\n    transform: translateY(10px);\r\n  }\r\n  to {\r\n    opacity: 1;\r\n    transform: translateY(0);\r\n  }\r\n}\r\n\r\n.profile-view-header {\r\n  margin-bottom: 1rem;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 1rem;\r\n\r\n  .back-to-reports-btn {\r\n    text-decoration: none;\r\n    color: #667eea;\r\n    font-size: 0.95rem;\r\n    font-weight: 500;\r\n    padding: 0;\r\n    transition: all 0.2s ease;\r\n    display: inline-flex;\r\n    align-items: center;\r\n    gap: 0.5rem;\r\n    align-self: flex-start;\r\n\r\n    &:hover {\r\n      color: #5568d3;\r\n      text-decoration: none;\r\n      transform: translateX(-5px);\r\n    }\r\n\r\n    i {\r\n      font-size: 1rem;\r\n    }\r\n  }\r\n\r\n  .profile-view-title {\r\n    font-size: 2rem;\r\n    font-weight: 700;\r\n    color: #2c3e50;\r\n    margin: 0;\r\n    display: flex;\r\n    align-items: center;\r\n\r\n    @media (max-width: 768px) {\r\n      font-size: 1.5rem;\r\n    }\r\n\r\n    i {\r\n      color: #667eea;\r\n    }\r\n  }\r\n}\r\n\r\n.profile-card {\r\n  border: none;\r\n  border-radius: 12px;\r\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);\r\n  overflow: hidden;\r\n  transition: all 0.3s ease;\r\n  max-height: calc(100vh - 200px);\r\n  display: flex;\r\n  flex-direction: column;\r\n\r\n  &:hover {\r\n    box-shadow: 0 6px 25px rgba(0, 0, 0, 0.12);\r\n  }\r\n\r\n  .card-body {\r\n    padding: 2.5rem;\r\n    overflow-y: auto;\r\n    overflow-x: hidden;\r\n\r\n    @media (max-width: 768px) {\r\n      padding: 1.5rem;\r\n    }\r\n\r\n    // Custom scrollbar styling\r\n    &::-webkit-scrollbar {\r\n      width: 8px;\r\n    }\r\n\r\n    &::-webkit-scrollbar-track {\r\n      background: #f1f1f1;\r\n      border-radius: 10px;\r\n    }\r\n\r\n    &::-webkit-scrollbar-thumb {\r\n      background: #667eea;\r\n      border-radius: 10px;\r\n\r\n      &:hover {\r\n        background: #5568d3;\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n.profile-section {\r\n  &:not(:first-child) {\r\n    margin-top: 2.5rem;\r\n  }\r\n\r\n  .profile-section-title {\r\n    font-size: 1.1rem;\r\n    font-weight: 700;\r\n    color: #667eea;\r\n    margin-bottom: 1.5rem;\r\n    padding-bottom: 0.75rem;\r\n    border-bottom: 2px solid #e8ecff;\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 0.5rem;\r\n\r\n    &::before {\r\n      content: \"\";\r\n      width: 4px;\r\n      height: 20px;\r\n      background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\r\n      border-radius: 2px;\r\n    }\r\n  }\r\n}\r\n\r\n// Grid container for profile fields (2 per row)\r\n.profile-grid {\r\n  display: grid;\r\n  grid-template-columns: repeat(2, 1fr);\r\n  gap: 1rem 4rem;\r\n\r\n  @media (max-width: 768px) {\r\n    grid-template-columns: 1fr;\r\n    gap: 0.75rem;\r\n  }\r\n}\r\n\r\n// Individual profile field\r\n.profile-field {\r\n  display: grid;\r\n  grid-template-columns: 150px 1fr;\r\n  gap: 1rem;\r\n  align-items: baseline;\r\n  padding: 0.5rem 0;\r\n\r\n  @media (max-width: 768px) {\r\n    grid-template-columns: 120px 1fr;\r\n    gap: 0.75rem;\r\n  }\r\n\r\n  // Full width field (spans 2 columns)\r\n  &.profile-field-full {\r\n    grid-column: 1 / -1;\r\n  }\r\n\r\n  dt {\r\n    font-weight: 600;\r\n    color: #666;\r\n    font-size: 0.875rem;\r\n    margin: 0;\r\n\r\n    @media (max-width: 768px) {\r\n      font-size: 0.85rem;\r\n    }\r\n  }\r\n\r\n  dd {\r\n    margin: 0;\r\n    color: #000;\r\n    font-size: 0.95rem;\r\n    font-weight: 400;\r\n    word-break: break-word;\r\n\r\n    @media (max-width: 768px) {\r\n      font-size: 0.9rem;\r\n    }\r\n\r\n    i.fa-check-circle {\r\n      font-size: 1.1rem;\r\n    }\r\n\r\n    i.fa-times-circle {\r\n      font-size: 1.1rem;\r\n    }\r\n  }\r\n}\r\n\r\n// Mobile responsive adjustments\r\n@media (max-width: 768px) {\r\n  .profile-view-container {\r\n    .profile-section {\r\n      margin-top: 1.5rem !important;\r\n\r\n      &:first-child {\r\n        margin-top: 0 !important;\r\n      }\r\n    }\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
